export default __webpack_public_path__ + "static/media/080_finish_good.av1.d8676a74.mp4";